import { LoadingButton } from '@mui/lab';
import React from 'react'

interface IUploadProps{
    id: string;
    type:string;
    onChange:(event:any)=>void;
    IconView:any;
    text?:string;
    accept?:string;
    disabled?:boolean;
    color?:"info" | "inherit" | "primary" | "secondary" | "success" | "error" | "warning" | undefined;
    loading?:boolean;
}

export const UploadButton:React.FC<IUploadProps> = ({
    id = 'id',
    type = 'file',
    onChange = (event:any)=>{ },
    IconView,
    accept = '',
    text = '',
    disabled = false,
    color='info',
    loading=false
}:IUploadProps) => {
    const fileRef = React.useRef<any>(null);
    const onClick = () =>{
        fileRef.current.click();
        return;
    }

    return (
      <div>
        <input accept={accept} id={id} type={type} ref={fileRef} multiple={false} hidden onChange={onChange} disabled={disabled} />
        <LoadingButton variant="contained" color={"primary"} onClick={onClick} disabled={disabled} loading={loading}>
            <IconView />&nbsp;
            {text}
        </LoadingButton>
      </div>
  )
}
